import {
  ResourceTypeAdapterInteface,
  ListResourceTypesInput,
} from 'src/adapter/ResourceTypeAdapterInterface';
import {
  ResourceTypeModelCreateAttributes,
  ResourceTypeModelUpdateAttributes,
  ResourceTypeModelAttributes,
} from 'src/models/ResourceTypeModel';
import { api } from 'boot/axios';
import { axiosErrorHandler } from 'src/error/handler/axiosErrorHandler';
export class AxiosResourceTypeAdapter implements ResourceTypeAdapterInteface {
  async listResourceTypes(
    conditions?: ListResourceTypesInput
  ): Promise<{ total: number; data: ResourceTypeModelAttributes[] }> {
    try {
      const res = await api.get('/resource-types', {
        params: conditions,
      });
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async getResourceType(id: string): Promise<ResourceTypeModelAttributes> {
    try {
      const res = await api.get(`/resource-types/${id}`);
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async createResourceType(
    attributes: ResourceTypeModelCreateAttributes
  ): Promise<ResourceTypeModelAttributes> {
    try {
      const res = await api.post('/resource-types', attributes);
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async updateResourceType(
    id: string,
    attributes: ResourceTypeModelUpdateAttributes
  ): Promise<ResourceTypeModelAttributes> {
    try {
      const res = await api.put(`/resource-types/${id}`, attributes);
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async deleteResourceType(id: string): Promise<boolean> {
    try {
      return await api.delete(`/resource-types/${id}`);
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
}
